import pricing from '../../supabase/functions/_shared/pricing.json';

// Single source of truth for what we charge. The file lives next to the Edge
// Functions because the checkout (ai-checkout) charges its amountCents; the
// web and scripts/outreach (prospecting emails) read the same file, so the
// page, the emails and Stripe always quote the same price.
export const FULL_REPORT_PRICE = pricing.fullReport.label;
export const FULL_REPORT_TAX_NOTE = pricing.fullReport.taxNote;

// Monthly GEO follow-up: not sold yet. The report offers a waitlist at this
// price to measure interest (the price is stored with each sign-up).
export const MONITORING_PRICE = pricing.monitoring.label;
export const MONITORING_PRICE_CENTS = pricing.monitoring.amountCents;
